import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'reimbursement-claim-submitted',
  templateUrl: './reimbursement-claim-submitted.component.html',
})

export class ReimbursementClaimSubmittedComponent {

  public baseClaimSubmissionWebUrl = `${environment.baseClaimSubmissionWebUrl}/reimbursement/rental-and-tow`;

}
